module.exports = __webpack_public_path__ + "static/women-smiling-square.9278531c.jpg";